module.exports = __webpack_public_path__ + "img/blue_bay_living_2.7102fa1f.jpeg";